export enum UserType {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3,
  SUPPORT = 16,
  ENGINEER = 17
}
